
import { SectorFilterOptions } from "../enums";
import { SectorField } from "./SectorField";

export class Sector {
    sectorCode: string;
    selection: SectorFilterOptions = SectorFilterOptions.ALL;
    filters: SectorField[];

    constructor(sectorCode: string, selection: SectorFilterOptions, filters: SectorField[]) {
        this.sectorCode = sectorCode;
        this.filters = filters;
        this.selection = selection;
    }

    hasFilter(componentId: string): boolean {
        return this.filters.some(filter => filter.componentId === componentId);
    }

    setSelection(selection: SectorFilterOptions) {
        this.selection = selection;
        if (selection === SectorFilterOptions.ALL || selection === SectorFilterOptions.NONE) {
            this.filters = [];
        }
    }

    addFilter(filter: SectorField) {
        this.filters.push(filter);
    }

    removeFilter(componentId: string) {
        this.filters = this.filters.filter(filter => filter.componentId !== componentId);
    }

    getFilter(componentId: string): SectorField | undefined {
        return this.filters.find(filter => filter.componentId === componentId);
    }

    setFilterValue(componentId: string, name:string, value: string | number) {
        const filter = this.getFilter(componentId);
        if (filter) {
            filter.setNameAndValue(name, value);
        }
    }

    getFilterValue(componentId: string): string | number | undefined {
        const filter = this.getFilter(componentId);
        return filter ? filter.getValue() : undefined;
    }

    getFilterStringValue(componentId: string): string | undefined {
        const filter = this.getFilter(componentId);
        return filter ? filter.getStringValue() : undefined;
    }
}